import getIntlWeekDays from '../../../../../../../../../../utils/getIntlWeekDays'

import getIntlTimeZones from 'src/utils/getIntlTimeZones'

const localeName = 'en-GB'

const weekDaysLong = getIntlWeekDays(localeName)
export const weekDaysShort = getIntlWeekDays(localeName)

export const daysOfWeek = weekDaysLong.map((name, index) => ({
  key: weekDaysShort[index],
  label: name,
}))

export const amountDaysOfWeek = daysOfWeek.length

const timeZones = getIntlTimeZones(localeName)
export const defaultHour = '00'
export const defaultMinute = '00'
export const timeZoneList = timeZones.map(({offset, name}) => ({
  key: name,
  label: `(${offset}) ${name}`,
}))

// eslint-disable-next-line new-cap
export const currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
